import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

const services = [
  {
    link: "/services/estate-cleanout/",
    img: "/assets/img/estate-cleanout.webp",
    title: "Estate Cleanout",
  },
  {
    link: "/services/office-cleanout/",
    img: "/assets/img/office-img-icon.webp",
    title: "Office Cleanout",
  },
  {
    link: "/services/storage-unit-cleanouts/",
    img: "/assets/img/storage-unit-cleanout.webp",
    title: "Storage Unit Cleanout",
  },
  {
    link: "/services/shed-removal/",
    img: "/assets/img/shed-img-icon.webp",
    title: "Shed Removal",
  },
  {
    link: "/services/appliance-removal/",
    img: "/assets/img/appliance-img.webp",
    title: "Appliance Removal",
  },
  {
    link: "/services/apartment-cleanout/",
    img: "/assets/img/appartment-cleanout.webp",
    title: "Apartment Cleanout",
  },
  {
    link: "/services/attic-cleanout/",
    img: "/assets/img/attic-cleanout.webp",
    title: "Attic Cleanout",
  },
  {
    link: "/services/cardboard-pickup/",
    img: "/assets/img/cardboard-img.webp",
    title: "Cardboard Recycling",
  },
  {
    link: "/services/carpet-disposal/",
    img: "/assets/img/carpet-img-icon.webp",
    title: "Carpet Disposal",
  },
  {
    link: "/services/concrete-pickup/",
    img: "/assets/img/concrete-img-icon.webp",
    title: "Concrete Removal",
  },
  {
    link: "/services/construction-debris-removal/",
    img: "/assets/img/construction-img-icon.webp",
    title: "Construction Waste Removal",
  },
  {
    link: "/services/electronic-junk-removal/",
    img: "/assets/img/electronics-img-icon.webp",
    title: "Electronics Junk Removal",
  },
  {
    link: "/services/foreclosure-cleanout/",
    img: "/assets/img/foreclosure-img-icon.webp",
    title: "Foreclosure Cleanout",
  },
  {
    link: "/services/furniture-removal/",
    img: "/assets/img/furniture-img-icon.webp",
    title: "Furniture Removal",
  },
  {
    link: "/services/garage-cleanout/",
    img: "/assets/img/garage-img-icon.webp",
    title: "Garage Cleanout",
  },
  {
    link: "/services/hot-tub-removal/",
    img: "/assets/img/hottub-img-icon.webp",
    title: "Hot Tub Removal",
  },
  {
    link: "/services/piano-removal/",
    img: "/assets/img/piano-img-icon.webp",
    title: "Piano Removal",
  },
  {
    link: "/services/scrap-metal-removal/",
    img: "/assets/img/scrap-img-icon.webp",
    title: "Scrap Metal Removal",
  },
  {
    link: "/services/yard-waste-removal/",
    img: "/assets/img/yard-img-icon.webp",
    title: "Yard Waste Removal",
  },
  {
    link: "/services/swing-set-removal/",
    img: "/assets/img/playset-img-icon.webp",
    title: "Playset Removal",
  },
  {
    link: "/services/deck-demolition/",
    img: "/assets/img/deck-img-icon.webp",
    title: "Deck Removal",
  },
  {
    link: "/services/fencing-removal/",
    img: "/assets/img/fence-img-icon.webp",
    title: "Fencing Removal",
  },
  {
    link: "/services/hoarder-cleanout/",
    img: "/assets/img/hoarder-img-icon.webp",
    title: "Hoarder Cleanout",
  },
];

const ServicesSlider = () => {
  const location = useLocation();
  const [showSlider, setShowSlider] = useState(false);

  // Handle Swiper unmount/remount to prevent DOM errors
  useEffect(() => {
    setShowSlider(false);
    const timeout = setTimeout(() => setShowSlider(true), 10);
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <div className="services-slider-container text-center">
      {showSlider && (
        <Swiper
          key={location.pathname}
          slidesPerView={1}
          spaceBetween={20}
          centeredSlides={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          loop={true}
          modules={[Autoplay]}
          breakpoints={{
            320: { slidesPerView: 2, spaceBetween: 20 },
            480: { slidesPerView: 3, spaceBetween: 20 },
            640: { slidesPerView: 3, spaceBetween: 20 },
            768: { slidesPerView: 3, spaceBetween: 30 },
            1024: { slidesPerView: 4, spaceBetween: 40 },
            1280: { slidesPerView: 5, spaceBetween: 40 },
            1440: { slidesPerView: 5, spaceBetween: 50 },
          }}
          className="services-slider"
        >
          {services.map((service) => (
            <SwiperSlide key={service.title}>
              <a href={service.link}>
                <div className="slider-service">
                  <div className="service-img-sec">
                    <img src={service.img} alt={service.title} />
                  </div>
                  <h4>
                    {service.title.split(" ").map((word, index) => (
                      <span key={index}>
                        {word}
                        <br />
                      </span>
                    ))}
                  </h4>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      <div className="services-btn-container d-flex justify-content-center">
        <a href="/services/">
          <button className="btn view-all-services-btn">
            All Services &nbsp;
            <img src="/assets/img/Black.svg" alt="Black icon" loading="lazy" />
          </button>
        </a>
      </div>
    </div>
  );
};

export default ServicesSlider;
